import { create } from 'zustand';

import {
    PermissionsCombinedState,
    permissionsSlice,
} from './permissions-store';

export const useRootStore = create<PermissionsCombinedState>((...args) => ({
    ...permissionsSlice(...args),
}));
